<template lang="pug">
  .simple.order-check
    slot(name="header")
    main
      section.shopping-cart-product-list.container
        Spinner(v-if="loading" :size="10" :thickness="2")
        .tree
          h3 Ordercheck
          ProductCategoryTree(:tree="tree")
            template(v-slot:item="{ item, style, depth }")
              .node(:class="{ 'has-children': item.children && item.children.length, 'is-open': item.open }")
                template(v-if="!(item.children && item.children.length)")
                  font-awesome-icon(
                    v-if="item.open"
                    :icon="{ prefix: 'fas', iconName: 'folder' }"
                    @click.prevent.stop="$set(item, 'open', !item.open)"
                  )
                  font-awesome-icon(
                    v-else
                    :icon="{ prefix: 'fas', iconName: 'folder' }"
                    @click.prevent.stop="$set(item, 'open', !item.open)"
                  )
                template(v-else)
                  font-awesome-icon(:icon="{ prefix: 'fas', iconName: 'folder' }")
                .content
                  template(v-if="!(item.children && item.children.length)")
                    a.name(href @click.prevent.stop="$set(item, 'open', !item.open)")
                      nobr {{ item.name }} &nbsp;
                      font-awesome-icon(:icon="item.open ? 'caret-up' : 'caret-down'")
                  template(v-else)
                    span.name
                      nobr {{ item.name }}
                  transition(name="slide-fade-down")
                    InfiniteProductList.infinity(
                      v-if="item.open && !(item.children && item.children.length)"
                      :section="getSection(item)"
                      :per-page="8"
                      pagination="infinite"
                      forced-orientation="preorder"
                    )
    slot(name="footer")
</template>

<script>
import Vue from 'vue';

import { mapActions } from 'vuex';
import { cloneDeep } from '@/helpers';

import NestedSet from '@/nested-set-lib';
import ProductCategoryTree from '@/extensions/shop/components/BudgetingTool/Partials/ProductCategoryTree';
Vue.component('ProductCategoryTree', ProductCategoryTree);

import Page from '@/views/Page';
import InfiniteProductList from '@/extensions/shop/components/InfiniteProductList';
// import ShopApi from '@/extensions/shop/store/api/shop';

export default {
    name: 'OrderCheck',
    extends: Page,
    data: () => ({
        loading: false,
        categories: [],
        tree: undefined
    }),
    components: {
        InfiniteProductList
    },
    methods: {
        getSection(item) {
            let section = {
                key: `order-check-section-${item.id}`,
                id: `order-check-section-${item.id}`,
                title: 'Order Check',
                content: 'This is the order check section.',
                type: 'text',
                shopCategories: [{ id: item.id }]
            };
            return section;
        },
        ...mapActions({
            fetchCategories: 'shop/fetchCategories'
        })
    },
    mounted() {
        this.loading = true;

        const init = () => Promise.all([this.fetchCategories().then(categories => (this.categories = categories))]);

        init().finally(() => {
            this.loading = false;
            if (this.categories.length) {
                const items = cloneDeep(this.categories);
                this.tree = NestedSet.createTree(items);
            }
        });
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.container
  margin: 0 auto

.simple.order-check,
.simple.order-check main
  @apply flex
  flex-direction: column
  flex-grow: 1

.simple.order-check
  main
    padding: 1rem
    @screen lg
      padding: 1rem 3rem
      padding-bottom: calc(50px + 1rem)
    .searching
      @apply flex
      flex-grow: 1

.tree
  position: relative
  margin-top: 20px
  padding: 30px
  // font-size: .85rem
  // font-weight: 400
  // line-height: 1.5
  &::v-deep
    // &  > .product-category-tree > ul > li:first-child:after
    //   top: 15px
    //   height: 15px
    .fa-folder-open, .fa-folder
      color: lighten($color-adenauer-orange, 25%)
      &.blue
        color: lighten($color-adenauer-blue, 25%)
    ul
      padding-left: 5px
      list-style: none
      li.tree-item
        position: relative
        padding-top: 5px
        padding-bottom: 5px
        padding-left: 15px
        box-sizing: border-box
        &:before
          position: absolute
          top: 13px
          left: 0
          width: 10px
          height: 2px
          margin: auto
          content: ''
          background-color: lighten($color-adenauer-blue, 40%)
        &:after
          position: absolute
          top: 0
          bottom: 0
          left: 0
          width: 2px
          height: 100%
          content: ''
          background-color: lighten($color-adenauer-blue, 40%)
        &:last-child:after
          height: 15px

    li.tree-item ul.tree-menu
      padding-left: 7px

    .node
      display: flex
      position: relative
      &.has-children:after
        position: absolute
        top: 20px
        bottom: 0
        left: 7px
        width: 2px
        content: ''
        background-color: lighten($color-adenauer-blue, 40%)
      svg
        margin-right: 4px
        margin-top: 2px
      .content
        margin-top: -2px
        flex: 1
        .infinity
          padding-top: 8px
          min-height: 100px
          .preorder-product
            margin-bottom: 2rem

    .gray
      color: theme('colors.gray.400')
</style>
